/* tslint:disable */
/* eslint-disable */
/**
 * chinaone-java
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { WarehouseNationGroupResVo } from './WarehouseNationGroupResVo';
import {
    WarehouseNationGroupResVoFromJSON,
    WarehouseNationGroupResVoFromJSONTyped,
    WarehouseNationGroupResVoToJSON,
    WarehouseNationGroupResVoToJSONTyped,
} from './WarehouseNationGroupResVo';

/**
 * 
 * @export
 * @interface ResponseListWarehouseNationGroupResVo
 */
export interface ResponseListWarehouseNationGroupResVo {
    /**
     * 接口状态码
     * @type {number}
     * @memberof ResponseListWarehouseNationGroupResVo
     */
    code?: number;
    /**
     * 接口返回消息
     * @type {string}
     * @memberof ResponseListWarehouseNationGroupResVo
     */
    message?: string;
    /**
     * 
     * @type {Array<WarehouseNationGroupResVo>}
     * @memberof ResponseListWarehouseNationGroupResVo
     */
    data?: Array<WarehouseNationGroupResVo>;
}

/**
 * Check if a given object implements the ResponseListWarehouseNationGroupResVo interface.
 */
export function instanceOfResponseListWarehouseNationGroupResVo(value: object): value is ResponseListWarehouseNationGroupResVo {
    return true;
}

export function ResponseListWarehouseNationGroupResVoFromJSON(json: any): ResponseListWarehouseNationGroupResVo {
    return ResponseListWarehouseNationGroupResVoFromJSONTyped(json, false);
}

export function ResponseListWarehouseNationGroupResVoFromJSONTyped(json: any, ignoreDiscriminator: boolean): ResponseListWarehouseNationGroupResVo {
    if (json == null) {
        return json;
    }
    return {
        
        'code': json['code'] == null ? undefined : json['code'],
        'message': json['message'] == null ? undefined : json['message'],
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(WarehouseNationGroupResVoFromJSON)),
    };
}

export function ResponseListWarehouseNationGroupResVoToJSON(json: any): ResponseListWarehouseNationGroupResVo {
    return ResponseListWarehouseNationGroupResVoToJSONTyped(json, false);
}

export function ResponseListWarehouseNationGroupResVoToJSONTyped(value?: ResponseListWarehouseNationGroupResVo | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'code': value['code'],
        'message': value['message'],
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(WarehouseNationGroupResVoToJSON)),
    };
}

